<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { getdataAmat } from './dataAmat.js';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
import config from '../../../../../configHttp';
import { inquiryFileImport, deletebackGroundTaskData, posting, fileImportUpload, getTemplateName, downloadLog, downloadOriginalDdocument,ImportGLFile,adjustManuallyImportGLFile,validateCreateCondition,reimportGL } from '../../../../api/home.js';
export default {
	name: 'FileImport',
	components: {
		uploadFileplus
	},
	data() {
		return {
			/* 搜索栏 */
			searchlist: this.projectType=='Amat' ? getdataAmat().searchlist : getdata().searchlist,
			searchdata: this.projectType=='Amat' ? getdataAmat().searchdata : getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: this.projectType=='Amat' ? getdataAmat().pagination : getdata().pagination,
			headData: JSON.parse(localStorage.getItem('FileImportheadData')) || this.projectType=='Amat' ? getdataAmat().headData : getdata().headData,
			outlist: JSON.parse(localStorage.getItem('FileImportoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			/* 表格 */
			updiag: false,
			glUpdiag: false,
			formlist: this.projectType=='Amat' ? getdataAmat().formlist : getdata().formlist,
			formdata: {
				type: '',
				name: '',
			},
			upfile: { filelist: [] },
			glUpfile: {},
			Count: 0,
			sort:"",
			order:""
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		// 应用材料定制化开始
		trigger() {
			ImportGLFile().then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.data);
					this.searrchForData();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		// 应用材料定制化结束
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('FileImportoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('FileImportheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//下载日志文件
		DownloadLog(id) {
			let params = {};
			params.id = id;
			downloadLog(params).then(res => {
				let strData = res.data;
				const T_URL = window.URL.createObjectURL(new Blob([strData]));
				const LINK = document.createElement('a');
				LINK.href = T_URL;
				LINK.setAttribute('download', '日志信息');
				LINK.click();
				window.URL.revokeObjectURL(T_URL);
			});
		},
		//下载源文件
		ScratchFile(data) {
			let params = {};
			params.id = data.id;
			let fileType = data.fileName.split('.');
			if (data.fileName.indexOf('.xlsx') != -1 || data.fileName.indexOf('.xls') != -1) {
				let req = {
					downUrl: config.baseURL + '/backGroundTask/downloadOriginalDdocument?id=' + data.id,
					typeObj: {
						toForm: false,
						fileType: fileType[fileType.length - 1],
						fileName: data.fileName
					}
				};
				this.$downloadcommon(req);
			} else {
				downloadOriginalDdocument(params).then(res => {
					let strData = res.data;
					const T_URL = window.URL.createObjectURL(new Blob([strData]));
					const LINK = document.createElement('a');
					LINK.href = T_URL;
					LINK.setAttribute('download', data.fileName);
					LINK.click();
					window.URL.revokeObjectURL(T_URL);
				});
			}
		},
		updiagtk() {
			validateCreateCondition().then(res => {
				if (res.data.code == '200') {
					getTemplateName().then(res => {
						if (res.data.code == '200') {
							this.upfile = { filelist: [] };
							this.formdata = {
								type: '',
								name: '',
							};
							this.formlist = this.projectType=='Amat' ? getdataAmat().formlist : getdata().formlist;
							this.formlist[1].selectval = res.data.data.map(v => {
								return {
									label: v.value,
									value: v.key
								};
							});
							this.updiag = true;
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
			
		},
		//过账、反过账
		againstexcessive(isPosting) {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择要过账或反过账的数据');
				return;
			}
			this.$showConfirm({
				message: '确认操作?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					params.ids = this.$refs.tablebox
						.getSelectionval()
						.map(v => v.id)
						.join(',');
					params.type = '0';
					params.isPosting = isPosting;
					posting(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('操作成功:' + res.data.data);
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//重新导入
		reimport(id) {
			let params = {};
			params.id = id;
			reimportGL(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.message);
					this.searrchForData();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//删除
		deleteTCode(id) {
			if (this.$refs.tablebox.getSelectionval().length == 0 && id == '-1') {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					if (id != '-1') {
						params.ids = id;
					} else {
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					}

					deletebackGroundTaskData(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		searrchForData() {
			let params = {};
			// params.criteriaJson = '{"batchNo":"","status":"","createTime_start":"","createTime_end":""}';
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort= this.sort;
			params.order= this.order;
			inquiryFileImport(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				}
			});
		},
		sortchange(data) {
					this.sort = data.prop;
					this.order = data.order == 'ascending' ? 'asc' : 'desc';
					this.searrchForData();
				},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		},
		/* 表格 */
		forsubmit(e) {
			if (this.upfile.filelist.length == 0) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = {};
			params.uploadFile = this.upfile.filelist.map(v => v.upfile);
			params.name = e.formdata.name;
			// params.taskDesc = e.formdata.taskDesc;
			params.templateID = e.formdata.type;
			fileImportUpload(params).then(res => {
				if (res.data.code == '200') {
					this.closeupdiag();
					this.searrchForData();
					this.$message.success('导入成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile = e;
		},
		glUpdiagtk() {
			this.glUpdiag = true;
		},
		glForsubmit(e) {
			if (this.$emptyandnull(this.glUpfile.upfile)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			if (this.glUpfile.filetype.toLowerCase()!='txt') {
				this.$message.error('请选择txt文件');
				return false;
			}
			let params = {};
			params.uploadFile =[]
			params.uploadFile[0] = this.glUpfile.upfile
			adjustManuallyImportGLFile(params).then(res => {
				if (res.data.code == '200') {
					this.glCloseupdiag();
					this.searrchForData();
					this.$message.success('导入成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		glCloseupdiag() {
			this.glUpdiag = false;
		},
		glGetuploadparams(e) {
			this.glUpfile = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
